import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';

@Component({
    selector: 'gtw-efile-ignore-modal',
    templateUrl: './ignore-modal.component.html',
    styleUrls: ['./ignore-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IgnoreModalComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  explanation = '';
  modalTitle = 'Add Explanation';
  minimise: boolean = false;

  private isInitialized = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext())
    );
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext())
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    if (!this.isInitialized) {
      this.isInitialized = true;
    }
    this.cdr.markForCheck();
  }

  save(): void {
    if (!this.explanation) {
      return;
    }
    this.requestGridUpdate.emit(this.explanation);
  }

  cancel(): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail: 'cancel',
      bubbles: true,
    });
    document.querySelector('gtw-efile-ignore-modal-ce')?.dispatchEvent(updateEvent);
  }

  onExplanationChange(value: string): void {
    this.explanation = value;
    this.cdr.detectChanges();
  }
}
